import { NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { AssetColorLabel, AssetStatus, GalleryAccessLevel, GalleryDto, GalleryFeedbackOption } from '@picflow/types';
import { getAllowedAndEnabledFeedbackOptions } from 'src/app/lib/get-allowed-feedback-options';
import { StateService } from 'src/app/services/state.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-asset-feedback-hints',
  templateUrl: './asset-feedback-hints.component.html',
  styleUrls: ['./asset-feedback-hints.component.scss'],
  standalone: true,
  imports: [NgIf, SvgComponent],
})
export class AssetFeedbackHintsComponent implements OnChanges {
  @Input({ required: true }) likes: number;
  @Input({ required: true }) is_liked: boolean;
  @Input({ required: true }) status: AssetStatus;
  @Input({ required: true }) color_label: AssetColorLabel;
  @Input({ required: true }) text_comments_total_count: number;
  @Input({ required: true }) annotation_comments_total_count: number;
  @Input({ required: true }) gallery: GalleryDto;
  @Input({ required: true }) accessLevel: GalleryAccessLevel;
  enabledAndAllowedFeedbackOptions: GalleryFeedbackOption[];
  showSettings: { [key: string]: boolean } = {};

  constructor(private state: StateService) {}

  ngOnChanges() {
    this.enabledAndAllowedFeedbackOptions = getAllowedAndEnabledFeedbackOptions(
      this.gallery,
      this.state.plan,
      this.accessLevel
    );
    const options = this.enabledAndAllowedFeedbackOptions;
    this.showSettings.favourite = options.includes('favourite') && !!this.likes;
    this.showSettings.approved = options.includes('flag') && this.status === 'approved';
    this.showSettings.rejected = options.includes('flag') && this.status === 'rejected';
    this.showSettings.color_label = options.includes('color_label') && !!this.color_label;
    this.showSettings.comment =
      (options.includes('comment') && !!this.text_comments_total_count) ||
      (options.includes('annotation') && !!this.annotation_comments_total_count);
    this.showSettings.any = !!Object.values(this.showSettings).filter(a => a).length;
  }
}
